export enum SideBarMenuItemsSecObjects {
    LinkOffererLines = 'LinkOferenteLineas'
}

export enum AppSecObjects {
    RutaPanelAdmin = 'RutaPanelAdmin',
    RutaAdminUsuarios = 'RutaAdminUsuarios',
    RutaAdminGrupos = 'RutaAdminGrupos',
    RutaAdminEtapas = 'RutaAdminEtapas',
    RutaAdminPerfiles = 'RutaAdminPerfiles',
    RutaAdminSectoresComerciales = 'RutaAdminSectoresComerciales',
    RutaAdminEventos = 'RutaAdminEventos',
    RutaWorkflowGrafo = 'RutaWorkflowGrafo'
}

export enum AdminPanelSecObjects {
    LinkTablaUsuarios = 'LinkTablaUsuarios',
    LinkTablaGrupos = 'LinkTablaGrupos',
    LinkTablaEtapas = 'LinkTablaEtapas',
    LinkTablaPerfiles = 'LinkTablaPerfiles',
    LinkTablaSectoresComerciales = 'LinkTablaSectoresComerciales',
    LinkTablaEventos = 'LinkTablaEventos'
}
